const MEDIA_TYPES = {
  app: { color: '#f26726', label: 'Add-On', shortLabel: 'Add-On' },
  audio: { color: '#da42db', label: 'Audio', shortLabel: 'AUD' },
  btc: { color: '#f26726', label: 'Presentation', shortLabel: 'BTC' },
  cad: { color: '#d0021b', label: 'CAD', shortLabel: 'CAD' },
  csv: { color: '#24a62b', label: 'CSV', shortLabel: 'CSV' },
  earthviewer: { color: '#6379de', label: 'Earthviewer', shortLabel: 'ETV' },
  ebook: { color: '#8a623d', label: 'eBook', shortLabel: 'eBook' },
  epub: { color: '#97cf00', label: 'ePub', shortLabel: 'ePub' },
  excel: { color: '#08872c', label: 'Excel', shortLabel: 'Excel' },
  folder: { color: '#555', label: 'Folder', shortLabel: 'Folder' },
  form: { color: '#01aeb4', label: 'Form', shortLabel: 'Form' },
  ibooks: { color: '#f0842e', label: 'iBooks', shortLabel: 'iBooks' },
  igs: { color: '#D0021B', label: 'IGS', shortLabel: 'IGS' },
  image: { color: '#9052e3', label: 'Image', shortLabel: 'Image' },
  keynote: { color: '#1baff9', label: 'keynote', shortLabel: 'keynote' },
  learning: { color: '#9052e3', label: 'Learning', shortLabel: 'EDU' },
  none: { color: '#999999', label: 'None', shortLabel: 'none' },
  numbers: { color: '#24da1c', label: 'Numbers', shortLabel: 'NUM' },
  oomph: { color: '#f0118c', label: 'Oomph', shortLabel: 'OOM' },
  pages: { color: '#ff9900', label: 'Pages', shortLabel: 'Pages' },
  pdf: { color: '#f01300', label: 'PDF', shortLabel: 'PDF' },
  potx: { color: '#f26724', label: 'POTX', shortLabel: 'POTX' },
  powerpoint: { color: '#f26724', label: 'Powerpoint', shortLabel: 'PPT' },
  project: { color: '#17a149', label: 'Project', shortLabel: 'Project' },
  prov: { color: '#888888', label: 'Prov', shortLabel: 'Prov' },
  rtf: { color: '#4d4d4d', label: 'RTF', shortLabel: 'RTF' },
  rtfd: { color: '#4d4d4d', label: 'RTFD', shortLabel: 'RTFD' },
  scrollmotion: { color: '#0098bc', label: 'Scrollmotion', shortLabel: 'SM' },
  stack: { color: '#222222', label: 'Stack', shortLabel: 'Stack' },
  twixl: { color: '#6379de', label: 'Twixl', shortLabel: 'Twixl' },
  txt: { color: '#555555', label: 'TXT', shortLabel: 'TXT' },
  '3d-model': { color: '#8B2D74', label: '3D-MODEL', shortLabel: '3DM' },
  vcard: { color: '#41ebe1', label: 'Vcard', shortLabel: 'Vcard' },
  video: { color: '#6a73ff', label: 'Video', shortLabel: 'Video' },
  visio: { color: '#38549e', label: 'Visio', shortLabel: 'Visio' },
  web: { color: '#038ac6', label: 'Web', shortLabel: 'Web' },
  word: { color: '#3ea2d9', label: 'Word', shortLabel: 'Word' },
  xr: { color: '#f26726', label: 'XR', shortLabel: 'XR' },
  zip: { color: '#fab600', label: 'Zip', shortLabel: 'Zip' },
  bnsk:{ color: '#f26724', label: 'BNSK', shortLabel: 'BNSK' },
  zunos:{color: '#d0021b', label: 'Zunos', shortLabel: 'Zunos'},
  dsr: {color: '#d0021b', label: 'DSR', shortLabel: 'DSR'},
};

export const PITCH_BUILDER_IGNORE_TYPES = [
  'app',
  'audio',
  'btc',
  'cad',
  'csv',
  'earthviewer',
  'ebook',
  'epub',
  'excel',
  'folder',
  'form',
  'ibooks',
  'image',
  'keynote',
  'learning',
  'none',
  'numbers',
  'oomph',
  'pages',
  'igs',
  'potx',
  'project',
  'prov',
  'rtf',
  'rtfd',
  'scrollmotion',
  'stack',
  'twixl',
  'txt',
  '3d-model',
  'vcard',
  'visio',
  'web',
  'word',
  'xr',
  'zip',
  'btc-drive-link'
]

export default MEDIA_TYPES;
